import React from 'react';
import styled from 'styled-components';
import ImageUploading from 'react-images-uploading';

import { FormSectionTitle } from 'styles/form';
import { FlexCenterVertical } from 'styles/flexbox';
import { borderRadius } from 'variables/general';
import { brand, brandLight, white } from 'variables/colors';
import { fontWeightBold, montserrat } from 'variables/font';

const UpdateContainer = styled(FlexCenterVertical)``;

const DropButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  height: 50px;
  padding: 14px 1.5em;
  color: ${brand};
  font-weight: ${fontWeightBold};
  font-size: 14px;
  font-family: ${montserrat};
  background-color: ${white};
  border: 1px solid ${brand};
  border-radius: ${borderRadius};
  cursor: pointer;
  opacity: 1;

  &:hover {
    background-color: ${brandLight};
  }
`;

const OrganizationLogo = ({ logo, images, setImages }) => {
  const onChange = (imageList, addUpdateIndex) => {
    setImages(imageList);
  };

  return (
    <>
      <FormSectionTitle>Organization Logo</FormSectionTitle>
      <ImageUploading
        multiple
        value={images}
        onChange={onChange}
        maxNumber={1}
        dataURLKey="data_url"
      >
        {({
          imageList,
          onImageUpload,
          onImageUpdate,
          isDragging,
          dragProps,
        }) => (
          <div>
            {imageList.length === 0 && (
              <UpdateContainer>
                {logo && <img src={logo} alt="" width="100" />}

                <DropButton
                  onClick={onImageUpload}
                  style={isDragging ? { background: brandLight } : undefined}
                  {...dragProps}
                >
                  {logo ? 'Upload New Logo' : 'Click or Drop here'}
                </DropButton>
              </UpdateContainer>
            )}

            {imageList.map((image, index) => (
              <UpdateContainer key={index}>
                <img src={image.data_url} alt="" width="100" />
                <DropButton
                  style={isDragging ? { background: brandLight } : undefined}
                  onClick={() => onImageUpdate(index)}
                >
                  Upload New Logo
                </DropButton>
              </UpdateContainer>
            ))}
          </div>
        )}
      </ImageUploading>
    </>
  );
};

export default OrganizationLogo;
